import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/phases')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/phase' })
  },
})
